import { useEffect, useState } from 'react';

import * as Hosts from '../../../Hosts';
import {
  simpleAxiosGet
} from '../../../Utils';

const ImageNL = ({ linkImage, width, height, fit, type, sClass, alt }) => {

  const [b64img, set_b64img] = useState('')

  const getImage = async (linkImage, width, height, fit) => {

    linkImage = linkImage.replace("temp.assec.pt", "cdn.assec.app")
    try {
      let res = await simpleAxiosGet('https://cdn.assec.app','/repo' + Hosts.APP_REPO_FOLDER + 'nl_image.php?img=' + linkImage + '&w=' + width + '&h=' + height + '&fit=' + fit)

      set_b64img(res)
      return true
    } 
    catch (error) {
      console.log('getImage error', error)

      return false
    }
  }

  useEffect(() => {

    if (linkImage !== undefined) {
      if(type !== 'img-nl') {
        getImage(linkImage, width, height, fit)
      }

    }
    else {
      set_b64img('')
    }

  }, [linkImage, width, height, fit, type])

  return (
    b64img !== undefined && b64img !== '' ?
      type === 'img' ?
        <img src={b64img.replace('data:image:/webp;base64', 'data:image/webp;base64')} className={sClass} width={width} height={height} alt={alt} />
      :
      type === 'img-nl' ?
        <img src={'https://cdn.assec.app/repo' + Hosts.APP_REPO_FOLDER + 'nl_image.php?img=' + linkImage + '&w=' + width + '&h=' + height + '&fit=' + fit} className={sClass} width={width} height={height} alt={alt} />
      :
        b64img
    :
    type === 'img-nl' ?
      <img src={'https://cdn.assec.app/repo' + Hosts.APP_REPO_FOLDER + 'nl_image.php?img=' + linkImage + '&w=' + width + '&h=' + height + '&fit=' + fit} className={sClass} width={width} height={height} alt={alt} />
    :
      ''
  )
};

export default ImageNL;
